import styled from 'styled-components'
import { fontWeights } from '@/styles'
import { Avatar, User, getTextColor, formatName } from './elements'

const Wrapper = styled.div<{ $color: string }>`
  display: flex;
  align-items: center;
  padding: 16px 16px 12px;
  justify-content: space-between;
  color: ${props => props.$color};
`

const CardText = styled.div`
  overflow-wrap: break-word;
  word-break: normal;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  padding: 4px 0 0 20px;
  align-self: flex-start;
  font-weight: ${fontWeights.medium};
  color: currentColor;
  font-size: 10px;
  line-height: 14px;
  letter-spacing: 2.4px;
  text-transform: uppercase;
`

type HeaderProps = {
  user: User
  score: string
  avatarUrl: string
}

const CardHeader: React.FC<HeaderProps> = ({ user: profile, score, avatarUrl, ...props }) => {
  return (
    <Wrapper $color={getTextColor(score)} aria-hidden>
      <Avatar avatarUrl={avatarUrl} width={50} height={50} border />
      <CardText>{formatName(profile)}</CardText>
    </Wrapper>
  )
}

export default CardHeader
